import { useLanguage } from '@/contexts/LanguageContext';

export default function SustainabilityHero() {
  const { t } = useLanguage();

  const tags = [
    { icon: 'ri-earth-line', label: t('永續發展', 'Sustainability', 'サステナビリティ') },
    { icon: 'ri-leaf-line', label: t('碳效益', 'Carbon Impact', '炭素効果') },
    { icon: 'ri-bar-chart-line', label: 'ESG' },
    { icon: 'ri-recycle-line', label: 'Plastics Reviving' },
    { icon: 'ri-loop-right-line', label: t('循環經濟', 'Circular Economy', 'サーキュラーエコノミー') },
  ];

  return (
    <section className="relative min-h-[580px] md:min-h-[660px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-top"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=sustainable%20green%20earth%20circular%20economy%20recycled%20plastic%20carbon%20reduction%20ESG%20environmental%20technology%20clean%20energy%20nature%20and%20industry%20balance%20professional%20wide%20angle%20photography%20green%20and%20blue%20accent%20lighting%20high%20resolution%20inspiring%20sustainability&width=1440&height=660&seq=sustain-hero-v1&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/42 via-black/28 to-black/12" />
      <div className="absolute top-0 right-0 w-[600px] h-[600px] opacity-20 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,184,148,0.32) 0%, transparent 65%)', zIndex: 2 }} aria-hidden="true" />
      <div className="absolute bottom-0 left-1/4 w-[450px] h-[350px] opacity-15 pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(2,115,194,0.25) 0%, transparent 65%)', zIndex: 2 }} aria-hidden="true" />

      <div className="relative w-full max-w-screen-xl mx-auto px-4 md:px-6 py-20" style={{ zIndex: 3 }}>
        <div className="max-w-[720px] bg-black/20 backdrop-blur-[2px] rounded-2xl px-8 py-8 md:px-10 md:py-10">
          <p className="text-[1rem] font-semibold text-brand-green uppercase tracking-widest mb-4">
            {t('永續與碳效益', 'Sustainability & Carbon Impact', 'サステナビリティと炭素効果')}
          </p>
          <h1
            className="font-bold text-white mb-6"
            style={{ fontSize: 'clamp(2rem, 4.2vw, 2.75rem)', lineHeight: '1.3' }}
          >
            {t('把廢棄塑膠減量，變成可被量化的', 'Turn Plastic Waste Reduction into', '廃プラスチック削減を定量化可能な')}
            <span
              style={{
                background: 'linear-gradient(90deg, #00B894 0%, #4FC3F7 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {t('碳效益資產', 'Quantifiable Carbon Assets', '炭素資産へ')}
            </span>
          </h1>
          <p className="text-white/85 mb-9 max-w-[640px]" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            {t(
              '聚量應用材料透過 PQernel® 技術，讓本來要焚化、掩埋或降階使用的回收塑膠，成為可再生、可追蹤、可計算碳效益的循環材料。從能源消耗、碳排放，到碳權與 ESG，我們協助企業把每一公斤再生塑膠，都轉化為品牌永續價值。',
              'PolyQ Applied Materials uses PQernel® technology to transform recycled plastics that would otherwise be incinerated, landfilled, or downgraded into renewable, traceable, carbon-benefit-calculable circular materials. From energy consumption and carbon emissions to carbon credits and ESG, we help enterprises transform every kilogram of recycled plastic into brand sustainability value.',
              '聚量応用材料はPQernel®技術を通じて、焼却・埋立・ダウングレード使用される予定だった回収プラスチックを、再生可能・追跡可能・炭素効果計算可能なサーキュラー材料へと転換します。エネルギー消費・炭素排出からカーボンクレジット・ESGまで、企業が再生プラスチック1kgをブランドの持続可能価値へと転換するよう支援します。'
            )}
          </p>
          <div className="flex flex-wrap gap-2.5">
            {tags.map((tag) => (
              <div key={tag.label} className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/25 backdrop-blur-sm">
                <i className={`${tag.icon} text-brand-green text-sm`}></i>
                <span className="text-white/90 text-[0.9375rem] font-medium whitespace-nowrap">{tag.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
